module.exports = __webpack_public_path__ + "afa6c4264673b1620e6e3e99ea907eae.pdf";